import {CalendarOutlined,DashboardOutlined,SettingOutlined,PlusSquareOutlined,EditOutlined,DeleteOutlined} from "@ant-design/icons";
import { Breadcrumb,Button,Modal,DatePicker,Form,Input,Space,Popconfirm,message, Spin } from "antd";
import { useContext, useRef, useState,useEffect } from "react";
import {Link} from "react-router-dom";
import DataTable from "../../components/common/table";
import Header from "../../components/dashboard/header";
import { useCreateFinanacialYear, useDeleteFinancialYear, useFetchAllFinancialYears, useUpdateFinancialYear } from "../../hooks/financialYear/financialYearQuery";
import { extractValueFromInputRef,scrollToTop } from "../../helpers/dom";
import RefreshContext from "../../context/refreshContext";


export const DUMMY_FINANCIAL_YEAR_DATA = [
    {
        key:'1',
        id:'1',
        name:'Financial year 2019',
        year:'2019'
    },
    {
        key:'2',
        id:'2',
        name:'Financial year 2020',
        year:'2020'
    },
    {
        key:'3',
        id:'3',
        name:'Financial year 2021',
        year:'2021'
    },
    {
        key:'4',
        id:'4',
        name:'Financial year 2022',
        year:'2022'
    },
    {
        key:'5',
        id:'5',
        name:'Financial year 2023',
        year:'2023'
    }

]


const financialYearTableColumns = [
    {
        title:"S/N",
        key:"s/n",
        render:(_,__,idx)=>idx+1
    },
    {
        title:"Name",
        dataIndex:"title",
        key:"name"
    },
    {
        title:'Year',
        dataIndex:'value',
        key:'year'
    },
    {
        title:"Actions",
        key:"actions",
        render: (_,year)=>(
            <FinancialYearEdit year={year}/>
        )
    },
]

function FinancialYearEdit({year}){
    const [isEditOpen,setIsEditOpen] = useState(false);
    const [fyear,setFYear] = useState("");
    const showEditModal = ()=> setIsEditOpen(true);
    const hideEditModal = ()=> setIsEditOpen(false);

    const titleRef = useRef(null);

    const {flag,setFlag} = useContext(RefreshContext);


    const updateFinancialYear = useUpdateFinancialYear();
    const deleteFinancialYear = useDeleteFinancialYear();


    const handleSubmit = async()=>{
      const payload = {
        title:extractValueFromInputRef(titleRef),
        value:fyear,
      }
      const {message:res} = await updateFinancialYear(year.id,payload);
      message.success(res??"financial year updated successfully");
      setIsEditOpen(false);
      setFlag(!flag);
      return;
    }
    const confirmDeleteFinancialYear = async()=>{
      const {message:response} = await deleteFinancialYear(year.id);
      message.success(response);
      setFlag(!flag);
      return;
    }

    return(
        <>
         <Space size="small" wrap>
            <Button type="primary" onClick={showEditModal}>
            <EditOutlined />
                Edit
            </Button>
            <Popconfirm
                 title="Delete this budget header"
                 description="Are you sure to delete this budget header?"
                 onConfirm={confirmDeleteFinancialYear}
                onCancel={()=>null}
                okText="Yes"
                cancelText="No"
                 >
                <Button type="primary" danger>
                    <DeleteOutlined />
                    Delete
                </Button>
            </Popconfirm>
             </Space>
            <Modal open={isEditOpen} title={'Edit financial year'} onCancel={hideEditModal} footer={null}>
                    <Form
                              wrapperCol={{
                                span: 24,
                              }}
                                initialValues={{
                                    title:year.title
                                }}
                              >
                          <Form.Item
                          name="title"
                           rules={[
                                    {
                                      required: true,
                                      message: 'Please input title for financial year!',
                                    },
                                  ]}>
                            <Input size="large" placeholder="name" ref={titleRef}/>
                          </Form.Item>
                          <Form.Item
                          name="value"
                           rules={[
                                    {
                                      required: true,
                                      message: 'Please Select a year !',
                                    },
                                  ]}>
                            <DatePicker onChange={(_,str)=>setFYear(str)} style={{width:'100%'}} picker="year" />
                          </Form.Item>
                          <Form.Item
                              wrapperCol={{
                                span:8,
                                offset:20
                              }}
                              className="submit-button-wrapper"
                            >
                              <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Submit
                              </Button>
                            </Form.Item>
                        </Form>
            </Modal>
        </>
    )
}




export default function FinancialYear(){
    const [isOpen,setIsOpen] = useState(false);
    const [year,setYear] = useState("");
    const showCreateModal = () => setIsOpen(true);
    const hideCreateModal = ()=> setIsOpen(false);

    const {flag,setFlag} = useContext(RefreshContext);

    useEffect(()=>{
      scrollToTop();
  },[]);



    const titleRef = useRef(null);

    const {loading,years:financialYears} = useFetchAllFinancialYears(flag);
    const createFinancialYear = useCreateFinanacialYear();


    const handleSubmit = async ()=>{
      const payload = {
        title:extractValueFromInputRef(titleRef),
        value:year
      };
      const {message:response} = await createFinancialYear(payload);
      message.success(response??"financial year created successfully");
      setFlag(!flag);
      setIsOpen(false);
    }


    return(
        <>
                <div className="main-container">
                        <Header/>
                        <div className="main-body">

                            <div className="info-bar">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                <SettingOutlined />
                                <Link to={"/dashboard"}>Configuration</Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <CalendarOutlined />
                                    <Link to="/dashboard/financial-year">Financial Year</Link>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                                <div>
                                    <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={showCreateModal}>
                                    <PlusSquareOutlined/>
                                        Create Financial Year
                                    </Button>
                                </div>
                            </div>

                            <div className="table-section">
                              <Spin spinning={loading}>
                                <DataTable cols={financialYearTableColumns} data={financialYears}/>
                              </Spin>
                            </div>
                        </div>
                    </div>
                    <Modal title={'Create Financial Year'} open={isOpen} onCancel={hideCreateModal} footer={null}>
                    <Form
                              wrapperCol={{
                                span: 24,
                              }}>
                          <Form.Item
                          name="name"
                           rules={[
                                    {
                                      required: true,
                                      message: 'Please input title for financial year!',
                                    },
                                  ]}>
                            <Input size="large" ref={titleRef} placeholder="name"/>
                          </Form.Item>
                          <Form.Item
                          name="year"
                           rules={[
                                    {
                                      required: true,
                                      message: 'Please Select a year !',
                                    },
                                  ]}>
                            <DatePicker style={{width:'100%'}} onChange={(date,str)=>setYear(str)} picker="year" />
                          </Form.Item>
                          <Form.Item
                              wrapperCol={{
                                span:8,
                                offset:20
                              }}
                              className="submit-button-wrapper"
                            >
                              <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                                Submit
                              </Button>
                            </Form.Item>
                        </Form>
                    </Modal>

        </>
    )
}
